import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import { CompanyInterface } from 'interfaces/company.interface';

const CompanyViewAnnouncement: React.FC = (): ReactElement | null => {
    const company = useSelector(
        (state: { company: CompanyInterface; }) => state.company
    );

    if (!company.announcement) {
        return null;
    }

    return (
        <div className="company-view__announcement">
            <div className="container" dangerouslySetInnerHTML={{ __html: company.announcement }} />
        </div>
    );
};

export default CompanyViewAnnouncement;
